import { apiClient } from '@/utils/api';

export interface Module {
  id: string;
  name: string;
  activityTypeCode: string | null;
  activityType?: {
    name: string;
    code: string;
    icon?: string;
  };
  filePath: string | null;
  originalName: string;
  mimeType: string | null;
  size: number | null;
  nasRelativePath: string | null;
  createdAt: string;
  updatedAt: string;
}

export const moduleService = {
  async getModules(): Promise<Module[]> {
    const response = await apiClient.get('/modules');
    return response.data?.data || [];
  },

  async createModule(formData: FormData): Promise<Module> {
    const response = await apiClient.post('/modules', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data?.data;
  },

  async createNasModule(name: string, nasRelativePath: string): Promise<Module> {
    const response = await apiClient.post('/modules/nas', { name, nasRelativePath });
    return response.data?.data;
  },

  async syncNasModules(files: string[]): Promise<{ data: Module[]; created: number }> {
    const response = await apiClient.post('/modules/sync-nas', { files });
    return { data: response.data?.data || [], created: response.data?.created || 0 };
  },

  async updateModule(id: string, formData: FormData): Promise<Module> {
    const response = await apiClient.put(`/modules/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data?.data;
  },

  async deleteModule(id: string): Promise<void> {
    await apiClient.delete(`/modules/${id}`);
  },

  getDownloadUrl(id: string): string {
    return `/modules/${id}/download`;
  },

  async getModulesByActivityType(code: string): Promise<Module[]> {
    const response = await apiClient.get(`/modules/activity-type/${code}`);
    return response.data?.data || [];
  },
};
